import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { EmailTemplateModel } from "./email-template-data-model";

export class EmailTemplateGridModel extends EmailTemplateModel { }

export class EmailTemplateListingModel extends GridModel<EmailTemplateGridModel> { }

export class EmailTemplateGridParams extends GridPostParams {
    pageNumber: 1;
    pageSize: 10;
    search_text: '';
    direction: '';
    column: ''
}